class multicontentTab extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.section-sidebar button');
    this.sections = [];
    this.suppressScroll = false;
  }

  connectedCallback() {
    window.addEventListener('scroll', this.onScrollHighlight.bind(this));

    this.buttons.forEach((button) => {
      button.addEventListener('click', this.onClickScroll.bind(this));

      const sectionId = button.getAttribute('data-section');
      const sectionElement = this.querySelector(`#${sectionId}`);
      if (sectionElement) {
        this.sections.push({
          id: sectionId,
          element: sectionElement,
          button: button,
        });
      }
    });
  }

  onClickScroll(e) {
    e.preventDefault();

    const sectionId = e.target.getAttribute('data-section');
    const sectionElement = this.querySelector(`#${sectionId}`);

    if (sectionElement) {
      this.suppressScroll = true;

      window.scrollTo({
        top: sectionElement.offsetTop - 60,
        behavior: 'smooth',
      });

      // Set timeout to re-enable scroll tracking after animation
      setTimeout(() => {
        this.suppressScroll = false;
      }, 800); // Adjust this based on scroll speed

      this.setActiveButton(e.target);
    }
  }

  onScrollHighlight() {
    if (this.suppressScroll) return;

    const middleScreen = window.scrollY + window.innerHeight / 2.5;

    for (const section of this.sections) {
      const rect = section.element.getBoundingClientRect();
      const sectionTop = window.scrollY + rect.top;
      const sectionBottom = sectionTop + section.element.offsetHeight;

      if (middleScreen >= sectionTop && middleScreen < sectionBottom) {
        this.setActiveButton(section.button);
        break;
      }
    }
  }

  setActiveButton(activeButton) {
    this.buttons.forEach((btn) => btn.classList.remove('active'));
    if (activeButton) {
      activeButton.classList.add('active');
    }
  }
}

customElements.define('multicontent-tabs', multicontentTab);
